import script from "./SavingStatus.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SavingStatus.vue?vue&type=script&lang=js"
export * from "./SavingStatus.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SavingStatus.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-pages/edit-article-page/elements/SavingStatus.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c7ef5992"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c7ef5992', __exports__)) {
    api.reload('c7ef5992', __exports__)
  }
  
}


export default __exports__